export const images = {
  hero: "https://images.unsplash.com/photo-1512048988843-7a307d5275dc?auto=format&fit=crop&w=1800&q=85",
  tower: "https://images.unsplash.com/photo-1662647326416-7f7bc8f86eef?auto=format&fit=crop&w=1000&q=85",
  curves: "https://images.unsplash.com/photo-1549564228-a52a15dcf797?auto=format&fit=crop&w=1000&q=85",
  corner: "https://images.unsplash.com/photo-1523524709877-a25a07f84b6a?auto=format&fit=crop&w=1000&q=85",
};

export const stats = [
  ["20+", "Years of experience"],
  ["2", "Cities with local teams"],
  ["1,200+", "Families & businesses served"],
  ["3,800+", "Properties handled"],
  ["₹350 Cr", "Assets guided"],
];

export const realEstate = [
  {
    slug: "commercial-leasing",
    label: "01 / REAL ESTATE",
    title: "Commercial Leasing",
    short: "Workspaces that work harder for your business.",
    description: "From high-street retail to signature office floors, we help you find commercial spaces with the right address, access and upside.",
    icon: "▥",
    image: images.tower,
    filters: ["Office space", "Retail", "Showroom"],
    properties: [
      { name: "The Meridian Floor", location: "Indore", type: "Office space", size: "3,200 sq ft", price: "₹1.85L / month", image: images.tower },
      { name: "Crown High Street", location: "Goa", type: "Retail", size: "1,450 sq ft", price: "₹95K / month", image: images.curves },
      { name: "Orbit Business Hub", location: "Indore", type: "Showroom", size: "5,800 sq ft", price: "₹2.4L / month", image: images.corner },
    ],
  },
  {
    slug: "plots-land",
    label: "02 / REAL ESTATE",
    title: "Plots & Land",
    short: "The right piece of land for your next chapter.",
    description: "Discover considered plots across emerging corridors in Indore and Goa, evaluated for title clarity, access and long-term potential.",
    icon: "⌂",
    image: images.curves,
    filters: ["Residential", "Commercial", "Farm land"],
    properties: [
      { name: "Aarambh Enclave", location: "Indore", type: "Residential", size: "2,400 sq ft", price: "₹74L onwards", image: images.curves },
      { name: "Riverbend Parcels", location: "Goa", type: "Farm land", size: "12,000 sq ft", price: "₹1.6 Cr onwards", image: images.tower },
      { name: "Sapphire Growth Zone", location: "Indore", type: "Commercial", size: "9,600 sq ft", price: "₹2.25 Cr onwards", image: images.corner },
    ],
  },
  {
    slug: "warehouse-leasing-sale",
    label: "03 / REAL ESTATE",
    title: "Warehouse Leasing & Sale",
    short: "Space to scale without compromise.",
    description: "Efficient logistics, compliant specifications and room to grow — our industrial advisory team makes every square foot count.",
    icon: "▤",
    image: images.corner,
    filters: ["Grade A", "Cold storage", "Industrial"],
    properties: [
      { name: "Mhow Logistics Park", location: "Indore", type: "Grade A", size: "42,000 sq ft", price: "₹18 / sq ft", image: images.corner },
      { name: "Verna Trade Yard", location: "Goa", type: "Industrial", size: "18,500 sq ft", price: "₹12 / sq ft", image: images.tower },
      { name: "North Ring Cold Store", location: "Indore", type: "Cold storage", size: "9,200 sq ft", price: "₹24 / sq ft", image: images.curves },
    ],
  },
];

export const investments = [
  { slug: "mutual-funds", title: "Mutual Funds", short: "Build wealth with a plan, not a hunch.", description: "Goal-led portfolios, disciplined investing and plain-English advice for every stage of your financial life.", icon: "↗", risk: "Market-linked", horizon: "3–7+ years", benefits: ["Goal-based portfolio design", "SIP & lump-sum planning", "Quarterly portfolio reviews"] },
  { slug: "life-health-insurance", title: "Life & Health Insurance", short: "Protect what your wealth makes possible.", description: "Thoughtful protection for your family, health and future income — built around real life, not fine print.", icon: "✦", risk: "Protection-first", horizon: "Long term", benefits: ["Human-first cover review", "Family & business protection", "Claims guidance when it matters"] },
  { slug: "share-trading", title: "Share Trading", short: "Make every decision with better context.", description: "A research-led approach to listed markets, combining timely insights with the discipline to stay aligned to your goals.", icon: "⌁", risk: "Market-linked", horizon: "As needed", benefits: ["Market insights & watchlists", "Risk-aware position sizing", "Regular strategy conversations"] },
  { slug: "gold-investment", title: "Gold Investment", short: "A timeless hedge for a modern portfolio.", description: "Explore gold as a measured part of a diversified portfolio, with guidance on digital, ETF and physical routes.", icon: "◇", risk: "Diversifier", horizon: "5+ years", benefits: ["Allocation guidance", "Digital & physical options", "Inflation-aware planning"] },
];

export const testimonials = [
  { quote: "Richcube Wealth Management has guided our family through property and investments for over a decade. The advice always feels personal.", name: "Anita & Rakesh Mehta", detail: "Clients since 2012 · Indore" },
  { quote: "They helped us move from a scattered portfolio to a plan we actually understand. That clarity is priceless.", name: "Raphael Fernandez", detail: "Investor · Goa" },
  { quote: "When we expanded our business, Richcube Wealth Management found the warehouse and negotiated like they were on our team.", name: "Nandini Shah", detail: "Business owner · Indore" },
];

export const insights = [
  {
    slug: "commercial-address-future-ready",
    category: "REAL ESTATE",
    date: "14 MAY 2024",
    readTime: "4 min read",
    title: "What makes a commercial address future-ready?",
    excerpt: "Access, tenant mix and the quiet signals that create durable value.",
    image: images.tower,
    body: [
      "A commercial address earns its premium long before the first tenant signs. The buildings that hold value through market cycles tend to share the same quiet fundamentals: effortless access, a credible neighbourhood, and specifications that do not age badly. Everything else is decoration.",
      "Start with access. In Indore, corridors like Vijay Nagar and the Super Corridor command attention because they sit where the city's growth is actually heading — near arterial roads, public transport and the talent pools that employers want. In Goa, the map works differently: access to NH-66 and the industrial belts of Verna and Ponda matters more than a postcard location.",
      "Next, study the tenant mix. A building anchored by credible, complementary tenants signals stability to every future occupant and lender. One strong anchor tenant can lift an entire address; a revolving door of short-stay occupants quietly erodes it.",
      "Finally, look at the unglamorous details — floor plates that can be subdivided, parking ratios, power backup, and compliance paperwork that is actually in order. These are the things that decide whether your exit in seven years is graceful or painful.",
      "Our advice after twenty years in these markets: buy or lease the boring fundamentals, and let the address do the compounding for you.",
    ],
    takeaways: [
      "Access beats aesthetics — growth corridors outperform fashionable pin codes over time",
      "A credible tenant mix is the strongest signal of durable rental value",
      "Flexible floor plates, parking and clean paperwork protect your eventual exit",
    ],
  },
  {
    slug: "calm-investors-guide-market-cycles",
    category: "INVESTING",
    date: "02 MAY 2024",
    readTime: "5 min read",
    title: "The calm investor's guide to market cycles",
    excerpt: "How a written plan helps you stay invested when the news gets loud.",
    image: images.curves,
    body: [
      "Every market cycle feels unprecedented while you are living through it. The headlines are louder, the swings feel sharper, and the urge to do something — anything — is strongest exactly when doing less would serve you better.",
      "The investors who come through cycles intact are rarely the cleverest. They are the ones with a written plan: a clear asset allocation, a defined goal for each rupee, and a rebalancing rhythm decided in calm times rather than improvised in stormy ones.",
      "A plan turns volatility from a threat into a mechanism. When equities fall, your systematic investments buy more units at lower prices. When markets run hot, rebalancing quietly moves gains into safer ground. None of this requires prediction — only discipline.",
      "It also helps to match money to time. Funds needed within three years have no business in volatile assets; money meant for a decade away can afford to ride out several cycles. Most investment regret comes from a mismatch between horizon and instrument, not from the market itself.",
      "If the news has you uneasy, that is a signal to revisit your plan — not to abandon it. And if you do not have a plan yet, a noisy market is the best possible reason to write one.",
    ],
    takeaways: [
      "A written allocation and rebalancing rhythm beats prediction in every cycle",
      "Systematic investing converts volatility into lower average costs",
      "Match each rupee to a time horizon before choosing an instrument",
    ],
  },
  {
    slug: "indore-goa-two-cities-different-opportunities",
    category: "LOCAL LENS",
    date: "18 APR 2024",
    readTime: "4 min read",
    title: "Indore & Goa: two cities, different opportunities",
    excerpt: "A closer look at the forces shaping these resilient local markets.",
    image: images.corner,
    body: [
      "We work in two markets that could not look more different on paper — and that is precisely why they work so well together in a portfolio. Indore is a growth engine; Goa is a scarcity play. Understanding the difference is the key to investing well in either.",
      "Indore's story is scale. Repeatedly ranked among India's cleanest and most liveable cities, it draws industries, students and logistics operators in equal measure. The Super Corridor, the upcoming metro and a steady pipeline of IT and manufacturing investment keep demand for commercial space, warehousing and plotted development broad-based and deep.",
      "Goa's story is constraint. Land is finite, regulation is strict, and demand arrives from across the country — hospitality, second homes, boutique retail and, increasingly, industrial and logistics users along the Verna–Ponda belt. Returns here are driven less by volume and more by choosing irreplaceable micro-locations.",
      "For investors, the two markets balance each other beautifully. Indore offers yield and steady absorption; Goa offers scarcity-driven appreciation and lifestyle value. The mistake we see most often is applying one city's logic to the other.",
      "Our teams live and work in both cities. If you are weighing where your next rupee should go, that local contrast is exactly the conversation we are built for.",
    ],
    takeaways: [
      "Indore rewards scale: commercial, warehousing and plotted growth along new corridors",
      "Goa rewards scarcity: micro-location quality drives long-term value",
      "Holding exposure to both balances yield with appreciation",
    ],
  },
];

export const offices = [
  { city: "Indore", address: "311, Apollo Premier, Vijay Nagar, Indore 452010", phone: "+91 93006 16777", accent: "01" },
  { city: "Goa", address: "14, Saudades Enclave, Panaji, Goa 403001", phone: "+91 93006 16777", accent: "02" },
];

export const residentialListings = [
  {
    slug: "luxury-studio-apartment-porvorim",
    title: "Luxury Studio Apartment",
    developer: "by GHD Infra",
    location: "Porvorim, North Goa",
    type: "Studio Apartment",
    highlights: ["Near Mandovi River"],
    rera: null,
    price: "Starting ₹1.03 Cr*",
    badge: "Exclusive Listing",
    image: "/listings/porvorim-studio.jpeg",
    contain: true,
  },
  {
    slug: "aria-residency-calangute",
    title: "Aria Residency",
    developer: "Azul Amor LLP · Managed by Eleva by Hiranandani",
    location: "Calangute, North Goa",
    type: "Apartments — 2 BHK & 3 BHK",
    highlights: ["Goa's First Wellness Living Residence", "78 boutique residences", "Hiranandani legacy"],
    rera: "PRGO04262718 & PRGO08262775",
    price: "Price on Request",
    badge: "Richcube Exclusive",
    image: "/listings/aria-residency.jpg",
  },
  {
    slug: "cloud-infinity-villas-calangute",
    title: "Cloud Infinity Premium Villas",
    developer: "Shree Yagna Builders · Managed by Eleva by Hiranandani",
    location: "Calangute, North Goa",
    type: "Villas — 3 BHK & 4 BHK",
    highlights: ["Exclusive gated villas", "Luxury lifestyle", "Premium North Goa location"],
    rera: "PRGO03262696",
    price: "Price on Request",
    badge: "Richcube Exclusive",
    image: "/listings/cloud-infinity-villas.jpg",
  },
];